import { useSelector } from 'react-redux';
import _ from 'lodash';
import InputForm from '../InputForm';
import { RootState } from '../../../../../../../state/store';
import formBalanceSheetTemplate from './formBalanceSheetTemplate.json';
import { getRowTemplate, getFormDataFromState, getForm } from '../../common/FormUtil';
import { FormGroup, FormType, FormGroupType, FormGroupI } from '../../../../../../../types/inputform.d';

export const generateFormBalanceSheet = (
  group: FormGroupType,
  balanceSheetCells: any,
  dbJson: any,
  loanDetails: any
) => {
  const formCells = _.cloneDeep(balanceSheetCells);
  let allRows: any[] = [];
  let formDataCells: any;

  if (!_.isEmpty(formCells)) {
    formDataCells = getFormDataFromState(formCells, group);
  } else if (_.isEmpty(formCells)) {
    const formBalanceSheet = _.cloneDeep(formBalanceSheetTemplate) as any;

    // Total Rows //
    allRows = getRowTemplate('label', formBalanceSheet);

    formDataCells = getForm(
      formCells,
      FormType[FormType.FORMBALANCESHEET].toLowerCase(),
      group,
      allRows,
      dbJson,
      loanDetails
    );
  }

  // if (group === FormGroup.PROJECTION) {
  //   Object.entries(formJson).map(([, cell]) => cell?.expr && cellUpdate(copyCells, cell, cell?.expr));
  // }
  return formDataCells;
};

export const FormBalanceSheet = ({ group }: FormGroupI) => {
  const cells = useSelector(
    (state: RootState) => state?.financeInputscreen?.cells![FormType[FormType.FORMBALANCESHEET].toLowerCase()]
  );

  if (!group || !cells) return <></>;

  const cellData: any = {};

  const actualsCells = Object.fromEntries(
    Object.entries(cells).filter(([, value]: any) => value?.group === FormGroup[FormGroup.ACTUALS].toLowerCase())
  );
  _.merge(cellData, actualsCells);

  if (group === FormGroup.PROJECTION) {
    const projectionCells = Object.fromEntries(
      Object.entries(cells).filter(
        ([, value]: any) => value?.group === FormGroup[FormGroup.PROJECTION].toLowerCase()
      )
    );
    _.merge(cellData, projectionCells);
  }

  return <InputForm cells={cellData} />;
};
